
if (!customElements.get('c2f-trustpilot-carousel')) {
 customElements.define('c2f-trustpilot-carousel', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const signal = this.abort.signal;
   const track = this.querySelector('.c2f-tp__track');
   const dialog = this.querySelector('dialog');
   const reduced = matchMedia('(prefers-reduced-motion: reduce)');
   const step = () => track.children[1].offsetLeft - track.children[0].offsetLeft;
   const instant = left => track.scrollTo({ left, behavior: 'instant' });
   const normalize = () => {
    if (this.direction < 0 && track.scrollLeft > 1) return;
    clearTimeout(this.settle);
    const n = Math.round(track.scrollLeft / step());
    if (n > 0) {
     track.style.scrollSnapType = 'none';
     for (let i = 0; i < n; i++) track.append(track.firstElementChild);
     instant(0);
     track.style.scrollSnapType = '';
    }
    this.moving = false; this.direction = 0;
   };
   const move = direction => {
    if (this.moving) return;
    this.moving = true; this.direction = direction;
    const amount = step();
    if (direction < 0) {
     track.style.scrollSnapType = 'none';
     track.prepend(track.lastElementChild);
     instant(amount);
     track.style.scrollSnapType = '';
    }
    requestAnimationFrame(() => track.scrollTo({ left: direction < 0 ? 0 : amount, behavior: reduced.matches ? 'instant' : 'smooth' }));
    this.settle = setTimeout(normalize, 1000);
   };
   track.addEventListener('scrollend', normalize, { signal });
   this.querySelector('[data-prev]').addEventListener('click', () => move(-1), { signal });
   this.querySelector('[data-next]').addEventListener('click', () => move(1), { signal });
   track.addEventListener('keydown', event => {
    if (event.target !== track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
   }, { signal });
   this.querySelectorAll('.c2f-tp__read').forEach(button => button.addEventListener('click', () => {
    const card = button.closest('.c2f-tp__card');
    const content = this.querySelector('.c2f-tp__dialog-content');
    content.replaceChildren(...['.c2f-tp__stars','h3','.c2f-tp__quote','footer'].map(selector => card.querySelector(selector).cloneNode(true)));
    content.querySelector('h3').id = dialog.getAttribute('aria-labelledby');
    this.opener = button;
    dialog.showModal();
   }, { signal }));
   this.querySelector('.c2f-tp__close').addEventListener('click', () => dialog.close(), { signal });
   dialog.addEventListener('close', () => this.opener?.focus({ preventScroll:true }), { signal });
   this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold:.15 });
   this.observer.observe(this);
   this.timer = setInterval(() => {
    if (this.visible && !document.hidden && !reduced.matches && !this.matches(':hover') && !this.contains(document.activeElement) && !dialog.open) move(1);
   }, 5000);
   this.querySelector('.c2f-tp__controls').hidden = false;
  }
  disconnectedCallback() { this.abort?.abort(); this.abort=null; clearInterval(this.timer); clearTimeout(this.settle); this.observer?.disconnect(); }
 });
}
